/**
 * 订单关接口
 */
const PREFIX = "checkmall-order";
let goodsApi = {
  /**
   * 接口模块 前缀
   */
  prefix: PREFIX,
  url: {
    /**创建订单 */
    orderAdd: "/api/order/add",
    /**订单项配置 */
    orderFormitem: "/api/order/orderInfo",
    /**查询预约信息*/
    searchApptInfo: "/api/order/searchApptInfo",
    /**更新订单*/
    updateOrder: "/api/order/updateOrderInfo",
    /**复制样品*/
    copyGoods: "/api/order/copyGoods",
    /**删除样品*/
    deleteGoods: "/api/order/deleteGoods",
    /**订单提交*/
    orderSubmit: "/api/order/submit",
    /**订单详情*/
    orderInfo: "/api/order/orderInfoByStepKey",
    /**订单列表*/
    // orderList: '/api/order/getList',
    /**订单列表*/
    orderList: "/api/order/getOrderList",
    /**订单复核*/
    orderReview: "/api/order/review",
    /**订单删除*/
    deleteOrder: "/api/order/deleteOrder",
    /**订单测回*/
    withdrawOrder: "/api/order/withdraw",
    /**再次送检-复制订单*/
    copyOrder: "/api/order/copyOrder",
    /**取消预约*/
    cancelAppt: "/api/order/cancelAppt",
    /**预约信息*/
    getOrderAppt: "/api/order/getOrderAppt",
    /**修改预约时间*/
    updateAppt: "/api/order/updateAppt",
    /**更新同步信息*/
    updateReport: "/api/order/updateReport",
    /**查询检测数据地址*/
    searchAnnexByOrderId: "/api/order/searchAnnexByOrderId",
    /**打印/查询委托单pdf*/
    searchEntrustPdf: "/api/order/searchEntrustPdf",

    /**查询预约信息*/
    searchAppt: "/api/order/searchAppt",
  },
};
export default goodsApi;
